import { render, staticRenderFns } from "./DetailsDisplay.vue?vue&type=template&id=71ec0606&scoped=true&"
import script from "./DetailsDisplay.vue?vue&type=script&lang=js&"
export * from "./DetailsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DetailsDisplay.vue?vue&type=style&index=0&id=71ec0606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec0606",
  null
  
)

export default component.exports